<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lQ2fgj/tc-custom/9781488039683.jpg?1725275550889" alt="This image is the cover for the book Holiday Kisses, Butterfly Harbor Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Holiday Kisses, Butterfly Harbor Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>Opposites attract when a city dweller comes to a small town and falls in love with a local woman in this sweet romance from a <i>USA Today</i>–bestselling author.</b><br/><br/>His family’s honor is at stake . . . And she holds the key <br/><br/>Calliope Jones, Butterfly Harbor’s free-spirited organic farmer, is the most vocal objector to Xander Costas and his design for the butterfly sanctuary that he hopes will save his family’s architectural firm. Strangely, it’s Calliope who shows him what the town, and he, really need. Calliope makes Xander listen with his heart. And soon his heart may be telling him to stay with this extraordinary woman!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna J. Stewart
      </h2>
      
      <p class="authorDescription body article">USA Today and national bestselling author Anna J. Stewart can&#39;t remember a time she didn&#39;t have a book in her hands or a story in her head. Early obsessions with <I>Star Wars, Star Trek,</I> and <I>Wonder Woman</I> set her on the path to creating sweet to sexy pulse-pounding romances for her independent heroines. Anna lives in Northern California where she deals with a serious <I>Supernatural </I>addiction and two monstrous cats named Rosie and Sherlock.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6661c152